import React from "react";
import PropTypes from "prop-types";
import * as yup from "yup";

import { FormGroupTitle, FormSwitchField, FormTextField } from "ui/Form";
import Alert from "ui/Alert";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { defaultLimitValueValidator } from "validators/licenseLimitValidators";

import {
  UPDATE_LICENSE_LIMIT,
  READ_LICENSE_LIMITS_NAME,
} from "graphqlQueries/licenses";

const validation = yup.object({
  default_value: defaultLimitValueValidator,
  enable: yup.boolean(),
});

const initialValues = (limitInfo) => ({
  id_limit_type: limitInfo.id,
  default_value: limitInfo.value,
  enable: limitInfo.enable,
});

const fieldsWithPlaceForError = ["default_value"];

const UpdateLicenseLimitDialog = (props) => {
  const { limitInfo } = props;

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_LICENSE_LIMIT}
      refetchQueries={[READ_LICENSE_LIMITS_NAME]}
      initialValues={initialValues(limitInfo)}
      validationSchema={validation}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`Update license limit "${limitInfo.name}"`}
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Limit information" />
      <FormTextField name="default_value" label="Value" type="number" />
      <div className="form-field-with-alert">
        <FormSwitchField
          name="enable"
          label="Enabled by default"
          disabled={limitInfo.lastEnabled}
        />
        {limitInfo.lastEnabled && (
          <Alert
            severity="warning"
            text="At least one limit should be enabled"
          />
        )}
      </div>
    </DialogFormWithMutation>
  );
};

UpdateLicenseLimitDialog.propTypes = {
  limitInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateLicenseLimitDialog;
